<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
                .card-container(ref='cardsContainer')
                        .card
                            img(src='../../assets/img/animated-scroll/card-face.svg')
                        .card
                            img(src='../../assets/img/animated-scroll/card-face.svg')
                        .card.center
                            img(src='../../assets/img/animated-scroll/card-shirt.svg')
                        .card
                            img(src='../../assets/img/animated-scroll/card-face.svg')
                        .card
                            img(src='../../assets/img/animated-scroll/card-face.svg')

            
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            let cards = this.$refs.container.querySelectorAll('.card');
            this.timeline
                .set(this.$refs.cardsContainer, {x: '100%'})
                .fromTo(this.$refs.cardsContainer, {x: '100%'}, {duration: 3, x: 0}, 0)
                .fromTo(cards[0], {x: '0'}, {duration: 3, x: '200%'}, 3)
                .fromTo(cards[1], {x: '0'}, {duration: 3, x: '100%'}, 3)
                .fromTo(cards[3], {x: '0'}, {duration: 3, x: '-100%'}, 3)
                .fromTo(cards[4], {x: '0'}, {duration: 3, x: '-200%'}, 3);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 150vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: #f00;
    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }
    &.bottom {
        bottom: 0;
        top: auto;
    }
}
.card-container {
    width: calc(var(--grid-column) * 17);
    display: flex;
}
.card {
    width: 25%;
    padding: 0 1%;
    z-index: 1;
    position: relative;
    &.center {
        z-index: 5;
    }
    img {
        display: block;
        width: 100%;
    }
}
</style>
